import axios from 'axios';
import { getToken } from '../utils/auth';

// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:6001/api'; // Local development
const API_URL = process.env.REACT_APP_API_URL || 'https://app.adsmash.org/api'; // Live URL

export interface AdblockStats {
  totalAdsBlocked: number;
  lastUpdated: string;
  isEnabled: boolean;
  domains: {
    domain: string;
    count: number;
  }[];
  series?: {
    date: string;
    blocked: number;
  }[];
}

export const getAdblockStats = async (): Promise<AdblockStats> => {
  const token = getToken();
  if (!token) {
    throw new Error('Not authenticated');
  }

  try {
    const response = await axios.get(`${API_URL}/adblocker/stats`, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      timeout: 5000, // 5 second timeout
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const updateAdblockStatus = async (): Promise<never> => {
  throw new Error('Updating AdBlock status is no longer supported from dashboard');
};
